import React from 'react';

export default function MarkdownRenderer({ content }) {
  if (!content) return null;

  const renderMarkdown = (text) => {
    const lines = text.split('\n');
    const elements = [];
    let i = 0;

    while (i < lines.length) {
      const line = lines[i];

      // H1
      if (line.startsWith('# ')) {
        elements.push(<h1 key={i} className="text-4xl font-bold text-slate-900 mb-6 mt-8">{line.substring(2)}</h1>);
      }
      // H2
      else if (line.startsWith('## ')) {
        elements.push(<h2 key={i} className="text-2xl font-semibold text-slate-800 mb-4 mt-6">{line.substring(3)}</h2>);
      }
      // H3
      else if (line.startsWith('### ')) {
        elements.push(<h3 key={i} className="text-xl font-semibold text-slate-700 mb-3 mt-5">{line.substring(4)}</h3>);
      }
      // Horizontal rule
      else if (line.trim() === '---') {
        elements.push(<hr key={i} className="my-8 border-slate-300" />);
      }
      // List item
      else if (line.trim().startsWith('- ') || line.trim().startsWith('• ')) {
        const listItems = [];
        while (i < lines.length && (lines[i].trim().startsWith('- ') || lines[i].trim().startsWith('• '))) {
          const text = lines[i].trim().substring(2);
          listItems.push(<li key={`li-${i}`} className="mb-2">{renderInlineFormatting(text)}</li>);
          i++;
        }
        elements.push(<ul key={`ul-${i}`} className="list-disc list-inside space-y-2 mb-4 text-slate-700">{listItems}</ul>);
        continue;
      }
      // Blockquote
      else if (line.trim().startsWith('>')) {
        elements.push(<blockquote key={i} className="border-l-4 border-blue-500 pl-4 italic text-slate-600 my-4">{line.substring(1).trim()}</blockquote>);
      }
      // Regular paragraph
      else if (line.trim()) {
        elements.push(<p key={i} className="text-slate-700 leading-relaxed mb-4">{renderInlineFormatting(line)}</p>);
      }
      // Empty line
      else {
        elements.push(<div key={i} className="h-2"></div>);
      }

      i++;
    }

    return elements;
  };

  const renderInlineFormatting = (text) => {
    const parts = [];
    let currentText = text;
    let key = 0;

    // Handle **bold**
    const boldRegex = /\*\*(.*?)\*\*/g;
    currentText = currentText.replace(boldRegex, (match, p1) => {
      return `__BOLD_${key++}_${p1}_BOLD__`;
    });

    // Handle *italic*
    const italicRegex = /\*(.*?)\*/g;
    currentText = currentText.replace(italicRegex, (match, p1) => {
      return `__ITALIC_${key++}_${p1}_ITALIC__`;
    });

    // Split and render
    const tokens = currentText.split(/(__BOLD_\d+_.*?_BOLD__|__ITALIC_\d+_.*?_ITALIC__)/);
    
    tokens.forEach((token, idx) => {
      if (token.startsWith('__BOLD_')) {
        const text = token.match(/__BOLD_\d+_(.*?)_BOLD__/)[1];
        parts.push(<strong key={idx} className="font-semibold text-slate-900">{text}</strong>);
      } else if (token.startsWith('__ITALIC_')) {
        const text = token.match(/__ITALIC_\d+_(.*?)_ITALIC__/)[1];
        parts.push(<em key={idx} className="italic">{text}</em>);
      } else if (token) {
        parts.push(<span key={idx}>{token}</span>);
      }
    });

    return parts;
  };

  return <div className="prose prose-slate max-w-none">{renderMarkdown(content)}</div>;
}
